<div class="container">
    <section>
        <div class="row">
            <div class="col-md-8 col-md-offset-2 text-center p-x-3">
                <i class="icono-arg-dire-genero-negativo icono-5x text-primary"></i>
                <h1><br>Proceso de firma Finalizado!</h1>
                <p class="lead margin-40">Se finalizo el proceso de firma correctamente</p>
                <p class="margin-60"><a routerLink="/buscar-tramite" class="btn btn-link p-y-1">Continuar</a>
                </p>
            </div>
        </div>
    </section>
</div>